module.exports = __webpack_public_path__ + "img/_ABS9738(1).bde53150.jpg";